<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <div
        class="h-full flex flex-col items-start justify-between p-12 bg-gradient-to-br from-white to-gray-50"
        style="width: 35vw"
      >
        <RouterLink to="/" aria-label="Visit homepage" class="hover:opacity-80 transition-opacity">
          <VuesticLogo :height="28" />
        </RouterLink>
        <div class="space-y-6">
          <h2 class="text-3xl font-bold text-gray-800">Welcome Back</h2>
          <p class="text-lg text-gray-600 max-w-md">
            Manage your conversations and connect with your customers seamlessly.
          </p>
        </div>
        <div class="text-sm text-gray-500">© {{ new Date().getFullYear() }} All rights reserved.</div>
      </div>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px] px-6">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-flex-start w-full">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <VuesticLogo class="mb-2" />
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import VuesticLogo from '../components/VuesticLogo.vue'

const breakpoint = useBreakpoint()
</script>
